import React, { useEffect } from 'react'
import { useListWhiteListHistoryQuery } from '../../redux/Api/WhitelistApiSlice'
import { Button, Modal } from 'antd'
import Loader from '../../pages/pages/loader'
import ReusableTable from '../other/ReuseableTable'
import { toast } from 'react-toastify'

const ShowWhiteListHistory = ({ state, open, setOpen, channel }) => {
  const { data: whitelistHistory, isLoading, error } = useListWhiteListHistoryQuery({
    id: channel?.id,
    params: {
      expand: ['customers', 'last_updated_by'].join(','),
      page: '*',
      ordering: '-id'
    }
  }, {
    skip: !channel?.id
  })

  useEffect(() => {
    if (error?.data) {
      const errorMessages = Object.values(error.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [error])

  let columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', sorter: true },
    {
      title: 'Channel Name',
      dataIndex: 'channel_name',
      key: 'channel_name',
      sorter: true,
      search: true
    },
    {
      title: 'Channel ID',
      dataIndex: 'channel_id',
      key: 'channel_id',
      sorter: true,
      search: true
    },
    
    {
      title: 'Customers',
      dataIndex: 'customers',
      key: 'customer_name',
      sorter: true,
      search: true,
      render: customers => (
        <p>{customers.map(c => c.customer_name).join(', ')}</p>
      )
    },
    {
      title: 'Last Updated By',
      dataIndex: 'last_updated_by',
      key: 'last_updated_by',
      render: (text, record) => {
        const { last_updated_by } = record
        return last_updated_by
          ? `${last_updated_by.first_name} ${last_updated_by.last_name}`
          : ''
      }
    },
    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (text, record) => {
        return record.is_active ? 'Active' : 'Deactivated'
      }
    }
  ]
  return (
    <Modal
      className='custom-modal'
      width={1200}
      open={open}
      title={`${channel?.channel_name} history`}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Close
        </Button>,
        
      ]}
    >
      <Loader isLoading={isLoading} />
      {whitelistHistory?.results ? (
        <ReusableTable data={whitelistHistory?.results} columns={columns} />
      ) : null}
    </Modal>
  )
}

export default ShowWhiteListHistory
